import { AxiosInstance } from 'axios';
import { createContextAwareHandlers } from './instance';
interface Response {
  setupIntentId: string;
  clientSecret: string;
}

export const createStripePaymentMethod = (instance: AxiosInstance) => async (customerId: string, weight?: number): Promise<PaymentMethod> => {
  const response = await instance.post<PaymentMethod>(`/customers/${customerId}/paymentmethods`, {
    type: 'stripe',
    weight: weight ?? 1,
  });
  return response.data;
};

export const createInvoicePaymentMethod = (instance: AxiosInstance) => async (
  billingInformation: BillingInformation,
  customerId: string,
  weight?: number,
): Promise<PaymentMethod> => {
  const { data } = await instance.post<PaymentMethod>(`customers/${customerId}/paymentmethods`, {
    type: 'invoice',
    weight: weight ?? 1,
    invoice: billingInformation,
  });
  return data;
};

export const createInvoicePaymentMethodForPartnership = (instance: AxiosInstance) => async (
  billingInformation: BillingInformation,
  partnershiId: string,
): Promise<unknown> => {
  const { data } = await instance.post<unknown>(`partnerships/${partnershiId}/paymentmethods`, { type: 'invoice', invoice: billingInformation });
  return data;
};

export const deletePaymentMethod = (instance: AxiosInstance) => async (customerId: string, paymentMethodId: string): Promise<unknown> => {
  const response = await instance.delete<unknown>(`/customers/${customerId}/paymentmethods/${paymentMethodId}`);
  return response.data;
};

export const setupCard = (instance: AxiosInstance) => async (customerId: string, paymentMethodId: string, weight: number): Promise<Response> => {
  const response = await instance.post<Response>(`/customers/${customerId}/paymentmethods/${paymentMethodId}/setup`, {
    type: 'stripe',
    weight: weight,
  });
  return response.data;
};

export const updateDefaultPaymentMethod = (instance: AxiosInstance) => async (
  customerId: string,
  paymentMethodId: string,
  weight: number,
): Promise<unknown> => {
  const response = await instance.put<unknown>(`/customers/${customerId}/paymentmethods/${paymentMethodId}`, { weight });
  return response.data;
};

const handlers = {
  createInvoicePaymentMethod,
  createStripePaymentMethod,
  deletePaymentMethod,
  setupCard,
  updateDefaultPaymentMethod,
  createInvoicePaymentMethodForPartnership,
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createPaymentMethodApi = (context: PortalContext) => {
  return createContextAwareHandlers(context, handlers);
};

export default createPaymentMethodApi;
